/**
 * @class documentsUpload
 *
 */
import React, { Component } from 'react';
import { Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import { createHashHistory } from 'history';
import UploadProgress from './documentsUploadProgress';
import DocumentsUploadSidebar from './documentsUploadSidebar';
import entityComposition from '../common/classes/entityComposition';
const hashHistory = createHashHistory();
class DocumentsUpload extends Component {
  componentWillUnmount() {
    const documentActions = this.props.documentActions;
    // clear the doc upload state so there aren't any lingering values
    documentActions.uploadClear();
  }
  render() {
    const _this$props = this.props,
      documentObj = _this$props.document,
      _this$props$document = _this$props.document,
      _this$props$document$ = _this$props$document.lastUploadedDocs,
      lastUploadedDocs = _this$props$document$ === void 0 ? [] : _this$props$document$,
      _this$props$document$2 = _this$props$document.pendingDocs,
      pendingDocs = _this$props$document$2 === void 0 ? [] : _this$props$document$2,
      notificationActions = _this$props.notificationActions;
    let progress = documentObj ? documentObj.progress : -1;
    const totalDocumentsToUpload = documentObj && pendingDocs && !lastUploadedDocs.length ? pendingDocs.length : lastUploadedDocs.length;
    if (progress === -1 && documentObj && lastUploadedDocs.length) {
      progress = 100;
    }
    const blockTransition = progress > 0 && progress < 100;

    // Prompt will trigger routerWillLeave
    const routerWillLeave = () => {
      notificationActions.info({
        headerMessage: 'You currently have an upload in progress.',
        message: 'Wait for completion to continue.',
        rightButtonLabel: 'Ok'
      });
      // The way we're doing the other routes, the URL is being updated, but navigation
      // is being blocked. In order to allow proper routing we've got to replace the route
      // with /library/upload, otherwise navigation fails on subsequent tries
      hashHistory.replace('/library/upload');
      return false;
    };
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Prompt, {
      when: blockTransition,
      message: routerWillLeave
    }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(DocumentsUploadSidebar, null)), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(UploadProgress, {
      progressPercent: progress,
      total: totalDocumentsToUpload
    }))));
  }
}
DocumentsUpload.propTypes = {
  document: PropTypes.shape({
    progress: PropTypes.number,
    pendingDocs: PropTypes.arrayOf(PropTypes.shape({})),
    lastUploadedDocs: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  // document redux store
  documentActions: PropTypes.shape({
    uploadClear: PropTypes.func
  }).isRequired,
  // document redux actions
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  }).isRequired
};
export { DocumentsUpload as TestDocumentsUpload };
export default entityComposition(DocumentsUpload, ['document'], {}, ['notification']);